// i18n area 'vms' — locale fi-FI (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.fi-FI.meta.json.
import type { enUS } from './vms'

export const fiFI: typeof enUS = {
  vms: {
    spof: {
      title: 'Riippumattomuus solmusta',
      single: 'Yksittäinen vikaantumispiste',
      alternativesNow: 'Vaihtoehdot nyt',
      structural: 'Rakenteen mukaan',
      binding: 'Sitova rajoite',
      movableNow: 'Siirrettävissä nyt',
    },
    title: 'Virtuaalikoneet',
    migratingChip: 'Migrointi käynnissä',
    templateChip: 'Template',
    expendableTooltip: 'Heikentyneessä klusterissa se pysäytetään ensimmäisten joukossa eikä välttämättä käynnisty uudelleen solmun menetyksen jälkeen.',
    expendableHaTooltip: 'Käynnistetään aina uudelleen, kun klusteri on terve; heikentyneessä klusterissa suojatut VM:t menevät edelle — se voidaan pysäyttää tai se voi jäädä sammuksiin, kunnes klusteri on taas ehjä, minkä jälkeen se palaa itsestään.',
    viewDetails: 'Näytä tiedot',
    profileLegacy: 'Muu OS',
    hugePagesNone: 'Ei mitään — tavallinen muisti',
    hugePages2M: '2 MiB:n sivut',
    hugePages1G: '1 GiB:n sivut',
    searchPlaceholder: 'Hae nimellä',
    name: 'Nimi',
    vcpus: 'vCPU',
    memory: 'Muisti',
    ipAddresses: 'IP-osoitteet',
    noIp: 'Ei IP-osoitetta',
    authorityNode: 'Authority',
    authorityNextStart: 'määrätään seuraavassa käynnistyksessä',
    scope: 'Scope',
    empty: 'Ei virtuaalikoneita',
    loadError: 'Virtuaalikoneita ei voitu ladata — onko TVirt-backend tavoitettavissa?',
    filterOverlay: 'overlay-verkko',
    filterDisk: 'levy',
    filterImage: 'levykuva',
    filteredBy: 'Suodatettu: {kind}',
    filterPhase: 'Vaihe',
    filterProtection: 'Suojaus',
    filterAll: 'Kaikki',
    filterScopePlaceholder: 'Suodata scopen mukaan',
    filtersToggle: 'Suodattimet',
    scopeTree: {
      title: 'Scope',
      all: 'Koko klusteri',
      noChildren: 'Ei ali-scopeja täällä',
      recursive: 'Sisällytä jälkeläiset',
      collapse: 'Pienennä scope-paneeli',
      up: 'Nouse tasoa ylemmäs',
      countTooltip: '{direct} VM:ää tässä scopessa · {total} jälkeläisten kanssa'
    },
    isoPicker: {
      catalog: 'Katalogi',
      unknownCatalog: 'Näkyvien katalogien ulkopuolella',
      noIsos: 'Ei valmiita ISO-levykuvia tässä katalogissa'
    },
    actionsHeader: 'Toiminnot',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Laitteisto',
      tags: 'Tagit',
      age: 'Ikä',
      disk: 'levy',
      disks: 'levyä',
      empty: 'Ei templateja — merkitse sammutettu VM templateksi tai kloonaa VM templateksi.',
      clone: 'Kloonaa / deploy',
      editTags: 'Muokkaa tageja',
      exportAction: 'Vie katalogiin (.tvtpl)',
      exportTitle: 'Vie katalogiin',
      exportSubmit: 'Vie',
      exportError: 'Vienti epäonnistui',
      exportHint: 'Template paketoidaan .tvtpl-arkistoksi (laitteistomanifesti + jokainen levy litistettynä qcow2:ksi) uudeksi Template VM -tiedostoksi valittuun katalogiin. NIC:t, CD/DVD-mediat ja cloud-init eivät kulje mukana — formaatin spec luettelee jokaisen tarkoituksellisen poisjätön.',
      exportName: 'Tiedoston nimi',
      exportNameHint: 'Tyhjä = <template>-export-<n>',
      exportStorageDefault: 'Templaten metadata-storage',
      importAction: 'Tuo katalogista',
      importTitle: 'Tuo katalogista',
      importHint: 'Valitun katalogin ready-tilassa oleva Template VM -tiedosto muuttuu inventaarion templateksi: tiedoston formaatti (tvtpl, ova, ovf tai paljas qcow2) päättää itse, miten tuonti tapahtuu — sinä valitset vain tiedoston.',
      importFile: 'Katalogitiedosto',
      importFileHint: 'Vain ready-tilassa olevat tiedostot voi tuoda — kesken uploadin olevaa ei',
      importNoFiles: 'Tässä katalogissa ei ole ready-tilassa olevia Template VM -tiedostoja — lataa tai vie ensin sellainen'
    },
    templateDetail: {
      quickDeploy: 'QuickDeploy-yhteensopivuus',
      quickDeployNone: 'Ei ilmoitettu',
      quickDeployHint: 'Ilmoita se vain, jos golden-levykuva sisältää cloud-initin (Linux) tai cloudbase-initin sysprep /generalize -komennon jälkeen (Windows): alusta luottaa ilmoitukseen eikä koskaan katso vieraan sisään.',
      notFound: 'Templatea ei löytynyt',
      frozen: 'Laitteistokokoonpano on jäädytetty: muokataksesi sitä muunna template takaisin VM:ksi. Nimi, muistiinpanot ja tagit pysyvät muokattavina.',
      storage: 'Storage',
      size: 'Koko',
      configTitle: 'Kokoonpano (jäädytetty)',
      usbClasses: 'Vaaditut USB-luokat',
      gpuClasses: 'Vaaditut GPU-luokat'
    },
    sharedDisksTab: {
      title: 'Jaetut levyt',
      sharing: 'Jakaminen',
      sharingNone: 'Yksi liitos',
      sharingMultiwriter: 'Jaettu kirjoitus (multiwriter)',
      sharingReadonly: 'Jaettu vain luku',
      usedBy: 'Käytössä',
      attachedTo: 'Liitetty',
      notAttached: 'Ei liitetty yhteenkään VM:ään',
      changeSharing: 'Vaihda jakotilaa',
      changeSharingTitle: 'Jakotila',
      changeSharingLocked: 'Tila vaihtuu vain, kun yksikään VM ei käytä levyä',
      sharingChanged: 'Jakotila päivitetty.',
      lun: 'Koko LUN',
      lunNumber: 'LUN / nimiavaruus',
      lunWwn: 'WWN',
      lunSerial: 'Sarjanumero',
      antiAffinityWarning: 'Kaksi tai useampi jäsen pyörii samassa solmussa ilman anti-affiniteettisääntöä: yhden solmun vika kaataa kaikki',
      antiAffinityCreate: 'Luo sääntö',
      createSourceLun: 'Ota käyttöön kohteen koko LUN',
      createLunNumber: 'LUN-numero (nimiavaruuden id NVMe:ssä)',
      createLunHint: 'Mitään ei varata: koko luetaan laitteelta käyttöönotossa',
      noPr: 'Tässä julkaisussa ei ole SCSI-3 persistent reservations -varauksia: klassisella jaetulla levyllä toimivaa Windows Failover Clusteria ei ole validoitu; verkon yli koordinoivat klusterit (GFS2/OCFS2, RHEL HA, shared-disk-tietokannat) on'
    },
    unusedDisksTab: {
      title: 'Käyttämättömät levyt',
      attach: 'Liitä VM:ään',
      attachTitle: 'Liitä VM:ään',
      vm: 'Virtuaalikone',
      noVms: 'Ei käytettävissä olevia VM:iä',
      noSlots: 'Ei vapaita sloteja tällä VM:llä',
      create: 'Luo levy',
      createTitle: 'Luo levy',
      createSourceBlank: 'Tyhjä levy',
      createSourceImage: 'Katalogin levykuvasta',
      createImage: 'Levykuva',
      createImageEmpty: 'Näkyvissä katalogeissa ei ole valmista VM-mallin levykuvaa',
      createSizeFromImageHint: 'Esitäytetty levykuvan virtuaalisella koolla — voi vain kasvaa',
      convert: 'Muunna VM-templateksi…',
      convertOnlyQcow2: 'Vain qcow2-levyjä voi muuntaa — raw ei ole rekisteröitävä template-formaatti',
      convertTitle: 'Muunna VM-templateksi',
      convertSubmit: 'Muunna (tuhoaa levyn)',
      convertError: 'Muunnosta ei voitu käynnistää',
      convertWarning: 'TUHOAVA: levystä tulee VM-template-tiedosto valittuun katalogiin — sama storage, nolla kopioitua tavua — ja se LAKKAA OLEMASTA levynä. Takaisin ei pääse muuten kuin luomalla templatesta uuden levyn.',
      convertNameHint: 'Katalogitiedoston nimi — oletuksena levyn nimi',
      convertConfirm: 'Ymmärrän: levy tuhotaan',
      convertStarted: 'Muunnos käynnistetty — template ilmestyy katalogiin, kun task valmistuu.',
      storageLockHint: 'Storage vaihtuu vain Siirrä-toiminnolla',
      source: 'Alkuperä',
      sourceClone: 'Toisen levyn klooni',
      sourceCloneLinked: 'Toisen levyn linked clone',
      sourceImage: 'Luotu levykuvasta',
      sourceBlank: 'Luotu tyhjänä',
      allocated: 'Varattu / virtuaalinen koko',
      observedAt: 'Havaittu',
      snapshots: 'Snapshotit',
      snapshotsEmpty: 'Ei snapshoteja'
    },
    phase: {
      defined: 'Ei koskaan käynnistetty',
      starting: 'Käynnistyy',
      running: 'Käynnissä',
      stopping: 'Sammuu',
      stopped: 'Sammutettu',
      paused: 'Tauolla',
      failed: 'Virhetilassa',
      deleting: 'Poistetaan'
    },
    stopCause: {
      'api': 'TVirtin sammuttama (toiminto tai API)',
      'guest-shutdown': 'Guest-käyttöjärjestelmän käynnistämä shutdown',
      'crash': 'Guestin crash',
      'qemu-exit': 'QEMU-prosessi päättyi odottamatta',
      'host-reboot': 'Solmu käynnistettiin uudelleen',
      'migrated': 'Migroitu toiselle solmulle',
      'fenced': 'HA-fencingin lopettama (solmu palasi)'
    },
    detail: {
      notFound: 'Virtuaalikonetta ei löytynyt',
      details: 'Tiedot',
      id: 'ID',
      scope: 'Scope',
      profile: 'Laitteistoprofiili',
      firmware: 'Firmware',
      firmwareFile: 'UEFI-firmwaren versio',
      firmwareUpdate: 'Päivitys saatavilla',
      firmwareUpdateHint: 'Alusta toimittaa uudemman UEFI-firmwaren. Päivitys ei tapahdu koskaan automaattisesti: se otetaan käyttöön VM sammutettuna, kun itse päätät.',
      arch: 'Arkkitehtuuri',
      node: 'Solmu',
      bootOrder: 'Boot-järjestys',
      agent: 'Agentin tila',
      agentConnected: 'Yhteydessä',
      agentNotConnected: 'Ei yhteyttä',
      protected: 'Suojattu',
      linkedClones: 'Linkitetyt kloonit',
      restartPolicy: 'Uudelleenkäynnistyskäytäntö',
      preferredNode: 'Ensisijainen solmu',
      noPreference: 'Ei suosikkia (automaattinen placement)',
      preferNodes: 'Ensisijaiset solmutagit',
      requireNodes: 'Pakolliset solmutagit',
      noPlacementTags: 'Ei mitään',
      placementTag: 'Tag',
      placementValue: 'Arvo',
      placementAddTag: 'Lisää tag',
      proximityHa: 'TVirt Proximityn HA',
      proximityHaRestarts: 'HA-uudelleenkäynnistystä',
      proximityHaGaveUp: 'crash loop — HA luovutti',
      failoverProtection: 'Suojaus heikentyneessä klusterissa',
      protectionProtected: 'Suojattu',
      protectionExpendable: 'Uhrattavissa heikentyneenä',
      protectionInherit: 'Peri',
      lastStop: 'Viimeisin sammutus',
      yes: 'Kyllä',
      no: 'Ei',
      tabOverview: 'Yleiskuva',
      tabSnapshots: 'Snapshotit',
      tabBackups: 'Varmuuskopiot',
      hardware: 'Laitteisto',
      name: 'Nimi',
      hwSystem: 'Järjestelmä',
      hwCpu: 'CPU',
      hwMemory: 'Muisti',
      hwBoot: 'Käynnistys',
      hwIdentity: 'Identiteetti',
      hwCluster: 'Klusteri ja agent',
      cpuTopology: 'CPU-topologia',
      cpuModel: 'CPU-malli',
      cpuLimit: 'CPU-raja',
      cpuWeight: 'CPU-paino',
      cpuNested: "Sisäkkäinen virtualisointi",
      cpuNestedHint: "Paljastaa vmx/svm:n vieraalle (vain CPU-mallilla host). Käynnissä olevassa VM:ssä muutos astuu voimaan seuraavassa power cyclessä (PendingRestart); sijoittelu hyväksyy vain solmut, joissa nested on käytössä.",
      unlimited: 'Rajoittamaton',
      memory: 'Muisti',
      balloon: 'Balloon',
      hugePages: 'Jättisivut',
      hugePagesTradeoff: 'Vähemmän osoitteenmuunnostyötä ja muistia, joka ei koskaan päädy levylle; vastineeksi varaus pysyy lukittuna solmuun niin kauan kuin virtuaalikone on käynnissä, muistia ei enää deduplikoida ja käynnistys epäonnistuu, jos solmussa on liian vähän vapaita sivuja.',
      disks: 'Levyt',
      cdroms: 'CD/DVD-asemat',
      nics: 'Verkkoliitännät',
      slot: 'Slot',
      disk: 'Levy',
      encrypted: 'Salattu',
      image: 'Levykuva',
      emptyDrive: 'Tyhjä asema',
      emptyOption: '(tyhjä)',
      network: 'Verkko',
      mac: 'MAC',
      connected: 'Kytketty',
      unplugged: 'Irrotettu',
      noDevices: 'Ei mitään',
      screenshot: 'Kuvakaappaus',
      capturedAt: 'Otettu klo',
      noCapture: 'Ei kaappausta',
      snapshotName: 'Nimi',
      snapshotCreated: 'Luotu',
      snapshotMemory: 'Muisti mukana',
      noSnapshots: 'Ei snapshoteja',
      pendingRestart: 'Muutoksia odottamassa: ne tulevat voimaan seuraavan power cyclen yhteydessä.',
      applied: 'käytössä',
      appliedHint: 'VM pyörii tällä arvolla — konfiguroitu arvo tulee voimaan seuraavan power cyclen yhteydessä.',
      actionError: 'Toiminto epäonnistui',
      actionStillRunning: 'Toiminto on yhä kesken — lopputulos ei ole vielä tiedossa',
      tabConsole: 'Konsoli',
      consoleConnect: 'Yhdistä',
      consoleDisconnect: 'Katkaise yhteys',
      consoleConnecting: 'Yhdistetään…',
      consoleReconnecting: 'Yhdistetään…',
      consoleUnavailable: 'Konsoli on käytettävissä, kun VM on käynnissä tai tauolla.',
      consoleError: 'Konsoliyhteys epäonnistui',
      consoleTaken: '{user} otti konsoli-istunnon',
      consoleReconnect: 'Yhdistä uudelleen',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Pidä {key} pohjassa',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Avaa koko näytölle uuteen välilehteen',
      consoleLoadFailed: 'VM:ää ei löytynyt tai oikeudet eivät riitä',
      consoleClose: 'Sulje',
      tabStats: 'Tilastot',
      tabTasks: 'Taskit',
      tabLogs: 'Lokit',
      statsCpu: 'CPU',
      statsMemory: 'Muisti',
      statsDisk: 'Levy-I/O',
      statsRange: 'Aikaväli',
      statsNoData: 'Ei dataa aikavälillä — tilastoja kerätään, kun VM on käynnissä.',
      statsError: 'Tilastoja ei voitu ladata',
      cpuUsage: 'Käyttöaste',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Käytössä',
      memGuestAvailable: 'Käytettävissä (guest)',
      schema: 'Skeema',
      consoleProtocol: 'Konsoli',
      agentEnabled: 'Guest agent',
      metadataStorage: 'Metadata-storage',
      startupOnBoot: 'Käynnistys bootissa',
      startupOrder: 'Käynnistysjärjestys',
      startupDelay: 'Käynnistysviive',
      seconds: 's',
      enabled: 'Käytössä',
      disabled: 'Pois käytöstä'
    },
    actionsAvailable: 'Käytettävissä olevat toiminnot',
    actions: {
      start: 'Käynnistä',
      stop: 'Sammuta',
      pause: 'Tauota',
      resume: 'Jatka',
      reset: 'Reset',
      migrate: 'Migroi',
      clone: 'Kloonaa',
      moveStorage: 'Siirrä storagelle…',
      moveScope: 'Siirrä scopeen…',
      openConsole: 'Avaa konsoli',
      forceStop: 'Pakota sammutus',
      markTemplate: 'Merkitse templateksi',
      unmarkTemplate: 'Muunna takaisin VM:ksi',
      error: 'Toimintoa ei voitu suorittaa'
    },
    cordon: {
      confirmTitle: 'Solmu on huoltotilassa',
      confirmHint:
        'Kordonia ei voi laskea, kun klusterin store on alhaalla. Vahvistamalla ilmoitat tietäväsi sen: VM käynnistyy siellä silti, ja suostumus jää tallennetuksi tehtävään.',
      confirm: 'Käynnistä silti'
    },
    markTemplate: {
      confirmTitle: 'Merkitäänkö {name} templateksi?',
      confirmBody: 'Kokoonpano jäädytetään eikä VM:ää voi enää käynnistää — vain kloonata tai muuntaa takaisin VM:ksi. Nimi, muistiinpanot ja tagit pysyvät muokattavina.',
      confirm: 'Merkitse templateksi',
      moved: '{name} on nyt template — se siirtyi Templatet-välilehdelle.'
    },
    unmarkTemplate: {
      confirmTitle: 'Muunnetaanko {name} takaisin VM:ksi?',
      confirmBody: 'Templatesta tulee taas tavallinen VM: muokattava ja käynnistettävä (seuraava käynnistys sijoittaa sen solmulle).',
      confirm: 'Muunna takaisin VM:ksi',
      moved: '{name} on taas virtuaalikone — se siirtyi Virtuaalikoneet-välilehdelle.'
    },

    // Round #123: riferimento a nodo per TAG (selettore #106) nei dialog
    // di start e migrazione — anteprima dell'insieme risolto inclusa.
    nodeByTag: {
      label: 'Solmutagin mukaan',
      hint: 'tag=arvo, pilkuin eroteltuna (AND): valitsija poimii vastaavien solmujen joukosta',
      invalid: 'Virheellinen muoto — käytä tag=arvo, pilkuin eroteltuna',
      resolved: 'Vastaavat jäsenet: {nodes}'
    },
    migrate: {
      title: 'Live-migraatio',
      submit: 'Migroi',
      target: 'Kohdesolmu',
      auto: 'Automaattinen (Proximity)',
      hint: 'VM siirtyy ilman power cycleä. Jokaisen storagen, jota se koskettaa, on oltava jaettu; tauolla oleva VM migroituu tauolla.',
      error: 'Migrointi hylättiin'
    },
    moveStorage: {
      title: 'Siirrä storagelle',
      submit: 'Siirrä',
      target: 'Kohde-storage',
      noTargets: 'Mikään storage ei ota vastaan levyjä',
      hint: 'Sammutetun VM:n kaikki levyt siirtyvät valitulle storagelle yksi kerrallaan id:nsä säilyttäen — jo perillä olevat ohitetaan. Edistyminen näkyy task-sivulla.',
      error: 'Siirto hylättiin'
    },
    moveScope: {
      title: 'Siirrä scopeen',
      submit: 'Siirrä',
      target: 'Kohde-scope',
      hint: 'VM vaihtaa scopea heti — id ja levyt säilyvät, owned-levyt seuraavat mukana, ja kone voi pysyä käynnissä. Nyt se elää scopessa {scope}. Näkyvyys muuttuu scopen mukana.',
      error: 'Scope-siirto hylättiin'
    },
    start: {
      title: 'Käynnistä VM',
      submit: 'Käynnistä',
      target: 'Kohdesolmu',
      auto: 'Automaattinen (suositeltu)',
      recommended: 'suositeltu',
      hint: 'Valitse kohdesolmu tai anna Proximityn päättää kelvollisten ehdokkaiden joukosta. Solmut, jotka eivät voi isännöidä konetta, on poistettu käytöstä syyn kera.',
      error: 'VM:ää ei voitu käynnistää'
    },
    console: {
      media: 'CD/DVD-asemat',
      mediaGuestToolsHint: 'Sisältää TVirt Guest Toolsit — täältä voit poistaa ne asemasta tai poistaa koko aseman',
      slotOpsDeferred: 'Tällä profiililla asemien lisäys ja poisto tulevat voimaan seuraavan power cyclen yhteydessä (median vaihdot ovat välittömiä).',
      mountGuestTools: 'Aseta TVirt Guest Tools asemaan',
      ejectGuestTools: 'Poista TVirt Guest Tools asemasta',
      bootOrder: 'Boot-järjestys',
      bootOrderHint: 'Uusi järjestys tallentuu heti ja tulee voimaan seuraavan power cyclen yhteydessä — konsoli-istunto pysyy yhdistettynä.'
    },
    snapshots: {
      create: 'Luo snapshot',
      createTitle: 'Luo snapshot',
      createSubmit: 'Luo',
      name: 'Nimi',
      nameHint: 'Kirjaimia, numeroita, piste, viiva, alaviiva.',
      consistencyHint: 'Konsistenssi on automaattinen: guest agent jäädyttää tiedostojärjestelmät, kun se vastaa; muuten VM menee hetkeksi tauolle snapshotin ajaksi.',
      memory: 'Sisällytä muisti',
      memoryHint: 'Kaappaa elävän RAM-muistin: palautus jatkaa VM:n suoraan käynnissä. Vaatii, että kaikki levyt ovat qcow2.',
      currentChip: 'Olet tässä',
      revert: 'Palauta',
      revertTitle: 'Palautetaanko {name}?',
      revertBody: 'Levyt palaavat snapshotin tilaan; kaikki sen jälkeen tapahtunut menetetään. Pelkkien levyjen snapshot vaatii, että VM on pysähdyksissä.',
      delete: 'Poista',
      deleteTitle: 'Poistetaanko snapshot {name}?',
      deleteBody: 'Palautuspiste katoaa; levyjen sisältö säilyy koskemattomana.',
      deleteMergeHint: 'Sen delta sulautuu kohteisiin {children}: jokainen myöhempi palautuspiste pysyy kelvollisena.',
      deleteDuplication: 'Hyväksyn monistuksen',
      deleteDuplicationHint: 'Delta kopioidaan jokaiseen {count} lukijasta (lapsi-snapshotit ja, jos tämä on nykyinen, aktiivinen pää): käytetty tila voi kasvaa pienenemisen sijaan.',
      error: 'Snapshot-operaatio hylättiin'
    },
    clone: {
      title: 'Kloonaa VM',
      submit: 'Kloonaa',
      name: 'Kopion nimi',
      storage: 'Levyjen kohde-storage',
      sameStorage: 'Sama kuin lähteellä',
      full: 'Täysi kopio',
      fullHint: 'Kopioi joka tavun ja katkaisee siteen lähdelevyihin. Oletus on linked clone: välitön, mutta kahlittu lähteeseen (vain qcow2).',
      hint: 'Klooni säilyttää lähteen kokoonpanon ja firmwaren; MAC-osoitteet ja TPM-identiteetti ovat uudet.',
      markAs: 'Kloonin tyyppi',
      markAsInheritVm: 'Kuten lähde (VM)',
      markAsInheritTemplate: 'Kuten lähde (template)',
      markAsVm: 'Virtuaalikone',
      markAsTemplate: 'Template',
      markAsHintVm: 'Valitse Template ylentääksesi kopion yhdellä askeleella.',
      markAsHintTemplate: 'Valitse Virtuaalikone tehdäksesi deployn tästä templatesta yhdellä askeleella.',
      error: 'Kloonaus hylättiin'
    },
    bulk: {
      selected: 'valittu',
      deleteTitle: {
        one: 'Poistetaanko {count} valittu VM?',
        other: 'Poistetaanko {count} valittua VM:ää?'
      },
      deleteBody: 'Jokainen VM käy läpi samat vartijat kuin yksittäinen poisto; hylkäykset raportoidaan kohteittain.',
      done: 'hyväksytty',
      refused: 'hylätty'
    },
    delete: {
      button: 'Poista',
      confirmTitle: 'Poistetaanko {name}?',
      confirmBody: 'Virtuaalikone ja sen omistamat levyt poistetaan. Operaatiota ei voi perua.',
      keepDisks: 'Säilytä levyt',
      keepDisksHint: 'VM:n mukana luodut levyt jäävät storagelleen itsenäisinä levyinä.',
      confirm: 'Poista',
      cancel: 'Peruuta',
      error: 'Poisto epäonnistui',
      blockedPhase: 'Sammuta VM ensin',
      blockedProtected: 'VM on suojattu — poista suojaus ensin',
      blockedDeleting: 'Poisto on jo käynnissä'
    },
    logs: {
      title: 'Lokit',
      subtitle: 'Tätä VM:ää koskettavien taskien strukturoidut loki-framet',
      when: 'Milloin',
      task: 'Task',
      level: 'Taso',
      message: 'Viesti',
      empty: 'Ei vielä lokeja',
      loadError: 'Lokeja ei voitu ladata — onko TVirt-backend tavoitettavissa?'
    },
    stop: {
      title: 'Sammuta virtuaalikone',
      modeGraceful: 'Graceful-sammutus',
      modeGracefulHint: 'Guest-käyttöjärjestelmää pyydetään sammumaan luonnollisesti (ACPI); jos se sivuuttaa pyynnön, timeoutin jälkeen laukeaa pakotettu sammutus.',
      modeForced: 'Pakotettu sammutus',
      modeForcedHint: 'Katkaisee virran heti, kuin töpselin irrottaminen.',
      timeout: 'Fallback-timeout (sekuntia)',
      timeoutHint: 'Guestille suotu odotusaika ennen sammutuksen pakottamista'
    },
    createFromScratch: 'Tyhjästä',
    createFromTemplate: 'Templatesta',
    createQuickDeploy: 'TVirt QuickDeploy',
    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Suorita deploy',
      error: 'Deploy epäonnistui',
      compatNote: 'QuickDeploy vaatii QuickDeploy-yhteensopivan mallin: alusta mukauttaa vieraan (verkko, toimialue, aktivointi) ensimmäisessä käynnistyksessä.',
      template: 'Malli',
      noTemplates: 'Yksikään malli ei vielä ilmoita QuickDeploy-yhteensopivuutta — ilmoita se Mallit-välilehdeltä (Linux cloud-initillä, Windows cloudbase-initillä sysprepin jälkeen)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Isäntänimi',
      hostnameHint: 'Isäntänimi tai FQDN; tyhjä = VM:n nimi (Windows: enintään 15 merkkiä)',
      ip: 'IP-osoite',
      ipHint: 'Isäntä ja etuliite, esim. 192.168.122.101/24; tyhjä = DHCP',
      gateway: 'Yhdyskäytävä',
      dns: 'DNS-palvelimet',
      dnsHint: 'Enintään kolme, pilkulla erotettuina',
      count: 'Instanssit',
      countHint: 'Useampi kuin yksi: nimetään <nimi>-1…-N, vain DHCP',
      user: 'Käyttäjä',
      userHint: 'Tyhjä = levykuvan oletuskäyttäjä (Linux) tai Administrator (Windows)',
      password: 'Salasana',
      passwordHint: 'Kirjoitetaan generoituun user-dataan, jonka alusta sitten julistaa salaiseksi: kukaan ei lue sitä enää',
      sshKeys: 'SSH-julkiset avaimet',
      sshKeysHint: 'Yksi riviä kohden (ssh-ed25519 AAAA… kommentti)',
      productKey: 'Windowsin tuoteavain',
      kmsServer: 'KMS-palvelin',
      kmsHint: 'Isäntä tai isäntä:portti — vaatii tuoteavaimen (KMS-asiakasavaimen)',
      adDomain: 'Liitä Active Directory -toimialueeseen',
      adDomainHint: 'Tyhjä = ei toimialueliitosta',
      adUser: 'Liitostili',
      adPassword: 'Liitostilin salasana',
      adOu: 'Kohde-OU (valinnainen)',
      advanced: 'Lisäasetukset: raa\'at dokumentit',
      userData: 'user-data (raaka)',
      userDataHint: 'Ohittaa generoidun user-datan: yllä olevien käyttäjän, salasanan, avainten ja Windows-kenttien on jäätävä tyhjiksi',
      networkConfig: 'network-config (raaka)',
      networkConfigHint: 'Ohittaa generoidun verkon: yllä olevien IP:n, yhdyskäytävän ja DNS:n on jäätävä tyhjiksi',
      secret: 'Käsittele raakaa user-dataa salaisena',
      secretHint: 'Salaiseksi merkittynä API ei enää palauta sitä kenellekään, ja Checkpointissa se kulkee masterpassilla sinetöitynä',
      startNow: 'Käynnistä heti',
      startNowHint: 'Jokainen instanssi käynnistyy heti kun se on määritelty; seed syntyy siinä käynnistyksessä'
    },
    create: {
      nicAttachmentNetwork: 'Looginen verkko (fabric)',
      nicNetwork: 'Looginen verkko',
      nicNetworkHint: 'SUOSITELTU tapa (F3): vNIC toteutuu palvelevan noden JOHDETULLA sillalla — silta syntyy fabricin eksplisiittisessä applyssa, ja käynnistys nodella, joka ei vielä kanna sitä, hylkää puhuen. Kun laivaston viimeinen viittaus lähtee, silta putoaa pois seuraavassa applyssa.',
      button: 'Luo VM',
      title: 'Luo virtuaalikone',
      dialogTitle: 'Luo virtuaalikone',
      stepGeneral: 'Yleiset',
      stepGeneralHint: 'Nimi ja profiili',
      stepCompute: 'CPU ja RAM',
      stepComputeHint: 'Topologia ja koot',
      stepDisks: 'Levyt',
      stepDisksHint: 'Luo tai liitä',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Asemat ja mediat',
      stepNetwork: 'Verkko',
      stepNetworkHint: 'NIC:t: trunk tai bridge',
      stepSummary: 'Yhteenveto',
      stepSummaryHint: 'Tarkista ja luo',
      name: 'Nimi',
      nameHint: 'Pienet kirjaimet, numerot ja viivat (DNS-1123)',
      nextButton: 'Seuraava',
      prevButton: 'Edellinen',
      submitButton: 'Luo',
      creating: 'Luodaan…',
      sockets: 'Socketit',
      cores: 'Coreja socketia kohden',
      threads: 'Threadeja corea kohden',
      totalVcpus: 'vCPU:t yhteensä',
      memoryGib: 'Muisti (GiB)',
      cpuModelHint: "'host' paljastaa hostin CPU:n",
      cpuLimitHint: 'Katto host-coreina — tyhjä = rajoittamaton',
      cpuNestedHint: "Paljastaa vmx/svm:n vieraalle, jotta se voi ajaa omaa hypervisoria — vaatii CPU-mallin host ja solmun, jossa nested on käytössä",
      newDisk: 'Uusi levy',
      attachDisk: 'Liitä olemassa oleva levy',
      diskStorage: 'Storage',
      diskSize: 'Koko (GiB)',
      diskSelect: 'Levy',
      addDisk: 'Lisää levy',
      addCdrom: 'Lisää CD/DVD-asema',
      addNic: 'Lisää verkkoliitäntä',
      remove: 'Poista',
      slotLimit: 'Slot-raja saavutettu',
      cdromImage: 'Levykuva (tyhjä asema, jos puuttuu)',
      nicAttachment: 'Kytkentä',
      nicAttachmentTrunk: 'Overlay-trunk',
      nicAttachmentBridge: 'Host-bridge',
      nicUntagged: 'Untagged overlay',
      nicUntaggedNone: 'Ei mitään (vain tagged)',
      nicTrunkHint: 'Vähintään toinen puoli: untagged overlay ja/tai tagged VLAN -mappaukset — VM voi pyöriä vain hosteilla, jotka jokainen viitattu overlay julistaa',
      nicTaggedVlan: 'VLAN-ID',
      nicTaggedOverlay: 'Overlay-verkko',
      addTagged: 'Lisää tagged VLAN',
      nicBridge: 'Host-bridgen nimi',
      nicBridgeHint: 'NM-bridge nimeltä — VM voi pyöriä vain palvelimilla, joiden host network julistaa tämän bridgen',
      nicMac: 'MAC (automaattinen, jos tyhjä)',
      noDisksHint: 'Ei levyjä: VM:llä on vain lisäämäsi CD/DVD-asemat.',
      noCdromsHint: 'Ei CD/DVD-asemia: lisää yksi käynnistääksesi ISO-levykuvasta.',
      mountGuestTools: 'Aseta TVirt Guest Tools asemaan ensimmäisessä käynnistyksessä',
      mountGuestToolsHint: 'Laittaa ISOn virtio-ajureineen ja guest agentteineen tyhjään CD-asemaan (lisätään tarvittaessa) — Windowsin asennusohjelma tarvitsee sitä nähdäkseen levyt.',
      noNicsHint: 'Ei verkkoliitäntöjä: VM käynnistyy ilman yhteyksiä.',
      taggedMappings: 'Tagged VLAN -mappaukset',
      summaryDevices: 'Laitteet',
      bootOrderTitle: 'Boot-järjestys',
      bootOrderHint: 'Raahaa järjestääksesi — ensimmäinen käynnistyskelpoinen laite voittaa; NIC:t käynnistävät PXE:n',
      bootOrderUp: 'Siirrä ylös',
      bootOrderDown: 'Siirrä alas',
      createError: 'Luonti epäonnistui'
    },
    edit: {
      button: 'Muokkaa',
      title: 'Muokkaa virtuaalikonetta',
      cancel: 'Peruuta',
      save: 'Tallenna',
      error: 'Muokkaus epäonnistui',
      modelStoppedOnly: 'Muokattavissa vain VM sammutettuna',
      firmwareStoppedOnly: 'Firmware on vaihdettavissa vain VM sammutettuna — seuraavassa käynnistyksessä kone käyttää uutta firmwarea ja UEFI-muuttujat säilyvät',
      hugePagesStoppedOnly: 'Muutettavissa vain virtuaalikoneen ollessa sammutettuna — seuraavassa käynnistyksessä muisti rakennetaan uudelle taustalle',
      runningHint: 'Muutokset tulevat voimaan seuraavan power cyclen yhteydessä',
      sectionCpu: 'CPU',
      sectionMemory: 'Muisti',
      sectionPolicy: 'Käytännöt'
    },
    devices: {
      networkChip: 'fabric-verkko',
      title: 'Laitteet',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Lisää USB-laite',
      addUsbTitle: 'Pyydä USB-laiteluokka',
      usbClassHint: 'VM pyytää USB-laitteiden LUOKKAA (usb-device-tagin arvoa), ei koskaan yksittäistä laitetta: käynnistyksessä konkreettinen vapaa laite valitaan ja varataan solmulta. Lisää tagit rekisteröidyille laitteille kohdassa Klusteri › USB- ja PCIe-resurssit.',
      usbTag: 'Tag (usb-device)',
      usbValue: 'Luokan arvo',
      noUsbTags: 'Ei usb-device-tageja — luo yksi ja lisää tagit rekisteröidyille laitteille kohdassa Klusteri › USB- ja PCIe-resurssit.',
      noUsbValues: 'Tällä tagilla ei ole vielä julistettuja arvoja.',
      usbEmpty: 'Ei USB-vaatimuksia — lisää luokka antaaksesi laitteen käynnistyksessä.',
      usbClassChip: 'luokka',
      usbPortChip: 'portti',
      usbUnclaimed: 'Ei varattua laitetta — ratkeaa VM:n käynnistyessä.',
      addGpu: 'Lisää GPU',
      addGpuTitle: 'Pyydä GPU-luokka',
      gpuClassHint: 'VM pyytää GPU-LUOKKAA (gpu-device-tagin arvoa), ei koskaan yksittäistä korttia: käynnistyksessä konkreettinen vapaa kortti valitaan ja varataan solmulta, ja koko sen IOMMU-ryhmä siirtyy YHDESSÄ. Lisää tagit rekisteröidyille GPU:ille kohdassa Klusteri › USB- ja PCIe-resurssit.',
      gpuTag: 'Tag (gpu-device)',
      gpuValue: 'Luokan arvo',
      noGpuTags: 'Ei gpu-device-tageja — luo yksi ja lisää tagit rekisteröidyille GPU:ille kohdassa Klusteri › USB- ja PCIe-resurssit.',
      noGpuValues: 'Tällä tagilla ei ole vielä julistettuja arvoja.',
      gpuEmpty: 'Ei GPU-vaatimuksia — lisää luokka antaaksesi kortin käynnistyksessä.',
      gpuClassChip: 'luokka',
      gpuGroupChip: 'IOMMU-ryhmä ×',
      gpuUnclaimed: 'Ei varattua korttia — ratkeaa VM:n käynnistyessä.',
      gpuPowerCycle: 'Ei GPU-hotplugia — muutokset pätevät seuraavasta power cyclestä (PendingRestart)',
      actions: 'Toiminnot',
      attachDisk: 'Lisää levy',
      attachDiskTitle: 'Lisää levy',
      attach: 'Liitä',
      noFreeDisks: 'Ei käyttämättömiä levyjä — luo yksi kohdassa Virtuaalikoneet › Käyttämättömät levyt.',
      addCdrom: 'Lisää asema',
      addCdromTitle: 'Lisää CD/DVD-asema',
      editCdromTitle: 'Vaihda CD/DVD-levykuva',
      changeMedia: 'Vaihda CD/DVD-levykuva',
      ejectMedium: 'Poista asemasta',
      mountGuestTools: 'Aseta TVirt Guest Tools asemaan',
      guestToolsMounted: 'TVirt Guest Tools asemassa',
      guestToolsClickMount: 'Laittaa TVirt Guest Tools -ISOn ensimmäiseen tyhjään CD/DVD-asemaan',
      guestToolsClickUnmount: 'Klikkaa poistaaksesi asemasta — asema jää, tyhjänä',
      guestToolsNoSlot: 'Ei tyhjää CD/DVD-asemaa — lisää asema (tai poista jokin media asemasta) asettaaksesi TVirt Guest Toolsit',
      guestToolsSkew: 'Liitetty v{pinned}; solmu {node} tarjoaa nyt version v{current}: poista ja liitä uudelleen päivittääksesi',
      ejectGuestTools: 'Poista TVirt Guest Tools asemasta (asema jää, tyhjänä)',
      guestToolsEjectConfirmTitle: 'Poistetaanko TVirt Guest Tools asemasta?',
      guestToolsEjectConfirmBody: 'Media poistetaan käynnissä olevasta VM:stä — CD/DVD-asema jää, tyhjänä.',
      applyLive: 'Ota käyttöön heti (VM on käynnissä)',
      addNic: 'Lisää liitäntä',
      addNicTitle: 'Lisää verkkoliitäntä',
      editNicTitle: 'Muokkaa verkkoliitäntää',
      bridgeChip: 'bridge',
      cable: 'Virtuaalikaapeli',
      plug: 'Kytke virtuaalikaapeli',
      unplug: 'Irrota virtuaalikaapeli',
      remove: 'Irrota',
      removeTitle: 'Irrotetaanko {device}?',
      removeBody: 'VM:n ollessa käynnissä muutos tulee voimaan seuraavan power cyclen yhteydessä. Levyt ja levykuvat irrotetaan, ei koskaan poisteta.'
    }
  }
}
